import { render } from "./SupportImprovementComponent.vue?vue&type=template&id=9399d730&scoped=true"
import script from "./SupportImprovementComponent.vue?vue&type=script&lang=js"
export * from "./SupportImprovementComponent.vue?vue&type=script&lang=js"

import "./SupportImprovementComponent.vue?vue&type=style&index=0&id=9399d730&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9399d730"]])

export default __exports__